module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "isb_box1"
  }, [_c('div', {
    staticClass: "isb_box2"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t1))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b1
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t2))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b2
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t3))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b3
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px",
      "padding": "0px 5px",
      "width": "100%"
    }
  }, [_c('label', {
    staticClass: "isb_tabel1"
  }, [_vm._v(_vm._s(_vm.t4))]), _vm._v(" "), _c('div', {
    staticClass: "isb_tabel2"
  }, [_c('input', {
    staticClass: "textbox counter_text line1",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.b4
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "line2"
  }, [_vm._v(_vm._s(_vm.u4))])])])])]), _vm._v(" "), (_vm.counter_b3_error_message != 'false') ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "-15px",
      "font-weight": "bold"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.counter_b3_error_message)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b76e4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory_summary_box.vue
// module id = 1012
// module chunks = 0